import { render, staticRenderFns } from "./borrowAndReturn.vue?vue&type=template&id=2505c34e&scoped=true&"
import script from "./borrowAndReturn.vue?vue&type=script&lang=js&"
export * from "./borrowAndReturn.vue?vue&type=script&lang=js&"
import style0 from "./borrowAndReturn.vue?vue&type=style&index=0&id=2505c34e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505c34e",
  null
  
)

export default component.exports